import { getCreditsDetails } from "@/apis/vip";
import { formatDate } from "@/utils";
import { message, Modal } from "antd"
import { useEffect, useState } from "react";
import './style.scss'

export const ComputeUsageModal = ({ open, onCannel, payCountObj }: { open: boolean, onCannel: () => void, payCountObj: any }) => {
    const [selectUseCount, setSelectUseCount] = useState('all')
    const [useCountList, setUseCountList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();



    useEffect(() => {
        const workGetCreditsDetails = async () => {
            await getCreditsDetails({
                limit: 999,
                offset: 0,
                type: selectUseCount
            }).then(res => {
                if (res?.count && Array.isArray(res?.list) && res?.list?.length) {
                    setUseCountList(res?.list)
                } else {
                    setUseCountList([])
                }
            }).catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            // console.log('vipurl', result)

        };
        if (open) {
            workGetCreditsDetails();
        }
    }, [open, selectUseCount])

    return <Modal
        className="price-model-count-list"
        width={'640px'}
        title={null}
        footer={null}
        open={open}
        maskClosable={false}
        onCancel={onCannel}
        destroyOnClose
        style={{ zIndex: 1001 }}

    >
        {contextHolder}
        <div className="count-list-wapper">
            <div className="count-list-back" onClick={onCannel}>
                <span>{'< 返回'}</span>
            </div>
            <div className="count-list-calc" style={{ marginTop: '16px' }}>
                <div className="count-list-calc-item">
                    <span className="count-list-calc-item-label">
                        剩余算力
                    </span>
                    <span className="count-list-calc-item-value">
                        {payCountObj?.recharge?.pay + payCountObj?.subscribe?.pay + payCountObj?.gift?.pay + payCountObj?.old?.pay}
                    </span>
                </div>
                <div className="count-list-calc-P">
                    =
                </div>
                <div className="count-list-calc-item">
                    <span className="count-list-calc-item-label">
                        订阅算力
                    </span>
                    <span className="count-list-calc-item-value">
                        {payCountObj?.subscribe?.pay}
                    </span>
                </div>
                <div className="count-list-calc-P">
                    +
                </div>
                <div className="count-list-calc-item">
                    <span className="count-list-calc-item-label">
                        充值算力
                    </span>
                    <span className="count-list-calc-item-value">
                        {payCountObj?.recharge?.pay}
                    </span>
                </div>
                <div className="count-list-calc-P">
                    +
                </div>
                <div className="count-list-calc-item">
                    <span className="count-list-calc-item-label">
                        赠送算力
                    </span>
                    <span className="count-list-calc-item-value">
                        {payCountObj?.gift?.pay}
                    </span>
                </div>
            </div>
            <div className="count-list-header" style={{ marginTop: '24px' }}>
                <div className="count-list-header-item" style={selectUseCount === 'all' ? { background: '#34383d' } : {}} onClick={() => setSelectUseCount('all')}>
                    <span>全部</span>
                </div>
                <div className="count-list-header-item" style={selectUseCount === 'consume' ? { background: '#34383d' } : {}} onClick={() => setSelectUseCount('consume')}>
                    <span>消耗</span>
                </div>
                <div className="count-list-header-item" style={selectUseCount === 'get' ? { background: '#34383d' } : {}} onClick={() => setSelectUseCount('get')}>
                    <span>获得</span>
                </div>
            </div>
            <div className="count-list-body">
                {
                    useCountList?.length
                        ? useCountList?.map(item => {
                            const currentTime = new Date(item?.time)
                            const dateString = formatDate(currentTime)
                            return (
                                <div key={item?.id} className="count-list-body-item">
                                    <div className="count-list-body-item-left">
                                        <span>{item?.name}</span>
                                        <span className="time" style={{ marginTop: '4px' }}>{dateString}</span>
                                    </div>
                                    <div className="count-list-body-item-right">
                                        <span style={item?.type !== 'consume' ? { color: '#446af6' } : {}}>{item?.type === 'consume' ? '-' : '+'}{item?.amount}</span>
                                    </div>
                                </div>
                            )
                        })
                        : null
                }
            </div>
        </div>
    </Modal>
}